
export const ORIENTATION_TYPE = Object.freeze([
    { value: "0", text: 'All' },
    { value: "1", text: 'Orientation' },
    { value: "2", text: 'Training' },
]);
